import firebase, { firestoreTimestampFromDate } from '@/plugins/firebase';

const db = firebase.firestore();

export async function createLog({
  action,
  accountId,
  universeId,
  dashboardId,
  userName,
  userEmail,
}) {
  try {
    const document = db
      .collection('logs')
      .doc(dashboardId);

    await document
      .set({
        action,
        accountId,
        universeId,
        userName,
        userEmail,
        date: firestoreTimestampFromDate(),
        status: 'success',
      });

    const documentSnapshot = await document.get();

    const snapshotReferenceData = await documentSnapshot.ref.get();

    return snapshotReferenceData.data();
  } catch (err) {
    console.error(err);
    return false;
  }
}

export async function updateStatusErrorLog(dashboardId) {
  try {
    const document = db
      .collection('logs')
      .doc(dashboardId);

    await document
      .update({
        date: firestoreTimestampFromDate(),
        status: 'error',
      });

    const documentSnapshot = await document.get();

    const snapshotReferenceData = await documentSnapshot.ref.get();

    return snapshotReferenceData.data();
  } catch (err) {
    console.error(err);
    return false;
  }
}
